import { useState, useEffect } from "react";
import { supabase } from "./supabase";
import AdminLogin from "./AdminLogin";
import AdminApp from "./pages/AdminApp";

// ─────────────────────────────────────────────────────────────────────────────
//  ADMIN ROUTE — mygharpe.com/manage
//  Uses a real Supabase Auth session. On load, it checks whether the current
//  session belongs to an admin (listed in admin_roles). No more sessionStorage
//  tokens that a user could forge.
// ─────────────────────────────────────────────────────────────────────────────

export default function AdminRoute() {
  const [admin, setAdmin]   = useState(null);
  const [checking, setCheck] = useState(true);
  const [lang, setLang]     = useState("en");

  // Given a Supabase user, confirm they're an admin and build the session object.
  const resolveAdmin = async (user) => {
    if (!user) return null;
    try {
      const { data: adminRow } = await supabase
        .from("admin_roles")
        .select("name, email")
        .eq("user_id", user.id)
        .single();
      if (adminRow) {
        return {
          name: adminRow.name || "Admin",
          email: adminRow.email || user.email,
          role: "admin",
          userId: user.id,
        };
      }
    } catch (e) { /* not an admin */ }
    return null;
  };

  useEffect(() => {
    let active = true;
    (async () => {
      const { data: { session } } = await supabase.auth.getSession();
      const resolved = await resolveAdmin(session?.user);
      if (active) {
        setAdmin(resolved);
        setCheck(false);
      }
    })();

    // React to sign-in / sign-out.
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      async (_event, session) => {
        const resolved = await resolveAdmin(session?.user);
        if (active) setAdmin(resolved);
      }
    );

    return () => { active = false; subscription.unsubscribe(); };
  }, []);

  const handleLogin = (session) => setAdmin(session);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    setAdmin(null);
  };

  if (checking) return (
    <div style={{
      minHeight: "100vh", background: "#0F2D5C",
      display: "flex", alignItems: "center", justifyContent: "center",
    }}>
      <div style={{
        width: 36, height: 36, border: "3px solid rgba(255,255,255,.2)",
        borderTopColor: "white", borderRadius: "50%",
        animation: "spin .7s linear infinite",
      }}/>
    </div>
  );

  if (!admin) return <AdminLogin onLogin={handleLogin}/>;

  return (
    <AdminApp
      lang={lang}
      setLang={setLang}
      onLogout={handleLogout}
      adminUser={admin}
    />
  );
}
